<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Radio/NewDRadioEditor'
export default {
  name: 'NewDCommentSettingEditor',
  extends: compoment
}
</script>
